import { Link } from "react-router-dom";
import MovieCard from "@/components/base/MovieCard";
import { getFeaturedMovies } from "@/mocks/movies";

export default function FeaturedSection() {
  const featured = getFeaturedMovies();

  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-screen-2xl mx-auto">
        <div className="mb-6">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            精选专题
          </h2>
          <p className="text-sm text-foreground-500 mt-1">编辑部精心挑选的必看佳作</p>
        </div>
        <div className="space-y-4">
          {featured.slice(0, 5).map((movie, index) => (
            <div key={movie.id} className="flex items-start gap-4 group">
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center shrink-0 rounded-lg bg-primary-100 text-primary-700">
                <span className="font-heading text-lg md:text-xl font-bold">{index + 1}</span>
              </div>
              <div className="flex-1 min-w-0">
                <Link
                  to={`/detail/${movie.id}`}
                  className="cursor-pointer"
                  onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                >
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                    {movie.title}
                  </h3>
                </Link>
                <p className="text-sm text-foreground-600 mt-1 line-clamp-2">{movie.summary}</p>
                <div className="flex items-center gap-3 mt-2 flex-wrap">
                  <span className="flex items-center gap-1 text-xs text-accent-600 font-medium">
                    <i className="ri-star-fill text-accent-500"></i>
                    {movie.rating}
                  </span>
                  <span className="text-xs text-foreground-400">{movie.category}</span>
                  <span className="text-xs text-foreground-400">{movie.year}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}